<div class="modal-body">
  <div class="inner-modal-body">
    <p>Are you sure you want to submit?</p>
    <div class="__actions gs keep-lay">
      <div class="lay-50 lay-left">
        <button class="btn btn-primary btn-sm btn-block" (click)="confirm()">{{ "common.yes" | translate }}</button>
      </div>
      <div class="lay-50 lay-right">
        <button class="btn btn-secondary btn-secondary-outline btn-sm btn-block"
          (click)="activeModal.dismiss('Cross click')">{{ "common.no" | translate }}</button>
      </div>
    </div>
  </div>
</div>